module.exports = __webpack_public_path__ + "static/create_calendar_example_carousel-f48ee246193fc0ac3c51efa3530cee29.png";